var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 148,
    viewBox: "0 0 146 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "url(#paint0_linear_4838_38840)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.9 58.8C120.06 58.8 121 59.7402 121 60.9C121 62.0598 120.06 63 118.9 63H81.1C79.9402 63 79 62.0598 79 60.9C79 59.7402 79.9402 58.8 81.1 58.8H118.9ZM116.8 27.3C117.96 27.3 118.9 28.2402 118.9 29.4V39.9C118.9 41.0598 117.96 42 116.8 42C115.64 42 114.7 41.0598 114.7 39.9V34.4694L101.485 47.6849C100.728 48.4419 99.5367 48.5002 98.7129 47.8596L98.5151 47.6849L93.7 42.8698L84.6849 51.8849C83.8648 52.705 82.5352 52.705 81.7151 51.8849C80.895 51.0648 80.895 49.7352 81.7151 48.9151L92.2151 38.4151C93.0352 37.595 94.3648 37.595 95.1849 38.4151L100 43.2301L111.726 31.5H106.3C105.223 31.5 104.335 30.6893 104.214 29.6449L104.2 29.4C104.2 28.2402 105.14 27.3 106.3 27.3H116.8Z",
    fill: "#AC92ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4838_38840",
    x1: 139.22,
    y1: 8.70588,
    x2: 74.5556,
    y2: 74.5457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7CFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStats);
export default __webpack_public_path__ + "static/media/stats.e1843b04374cceb0d8a41c78deb20ad5.svg";
export { ForwardRef as ReactComponent };